import type {PageRouteConfig} from '@router';

import Tickets from 'modules/Tickets/Tickets';
import {sanitizeRedirect} from 'utils/Helper';

export function createTicketsRoute(): PageRouteConfig {
  return {
    element: <Tickets />,
    layout: {
      title: 'پشتیبانی',
      hasNavigate: false,
      hasHeader: true,
      hasBack: true,
      hasLeftIcon: true,
      resolveLink: (ctx) => {
        const fallback = `/profile/${ctx.selectedVendor?.id ?? '0'}`;
        const from = new URLSearchParams(ctx.location?.search).get('from');

        return from ? sanitizeRedirect(from, fallback) : fallback;
      },
      headerDataKey: 'tickets'
    },
    initialHeaderData: {
      tickets: {icon: '', iconTitle: '', action: null, title: '', badgeNumber: 0}
    }
  };
}
